// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".array-sorting__movies {\n  border: 1px solid #eee;\n}\n.array-sorting__movies tbody tr:nth-child(odd) {\n  background-color: #eee;\n}", ""]);
// Exports
module.exports = exports;
